import React, { useState, useEffect } from 'react';
import { translate } from 'react-switch-lang';
import { ListingDatatable } from '../../_fragments';
import Form from './Form';
import { assetModelSchema as schema } from '../../_validationSchema';
import { assetModelAction as actions } from '../../_action/assetModel.action';
import { assetModel_model as model } from '../../_model';
import { assetModelConstants as constants } from '../../_constants';
import { assetGroupConstants as group_constants } from '../../_constants';

import { useSelector } from 'react-redux';

const AssetModel = (props) => {
  const { t } = props;

  const header = { name: 'AssetModel', icon: 'cubes' };
  const reducer = useSelector((state) => state.assetModelOperation);
  const [item, setItem] = React.useState({});

  const filenameXML = 'asset-model';
  const menuCode = 'M_ASSET_MODEL';
  const columns = [
    { title: t('code'), field: 'Code' },
    { title: t('description'), field: 'Description' },
    { title: t('assetClass'), field: 'AssetClass' },
    { title: t('assetSubClass'), field: 'AssetSubClass' },
    { title: t('assetGroup'), field: 'AssetGroup' },
  ];
  let useService = () => {
    return [schema, actions, model, constants, group_constants];
  };
  const [open, setOpen] = useState(false);
  const [selectedCode, setSelected] = useState('');
  const [type, setFormType] = useState('');
  const [keyTrigger, setTrigger] = useState(false);
  useEffect(() => {
    if (open === false) {
      setFormType('');
      setTrigger(!keyTrigger);
    }
  }, [open]);
  useEffect(() => {
    if (reducer.getSuccess) {
      setItem(reducer.data.data.info);
    }
  }, [reducer]);
  return (
    <>
      <Form
        type={type}
        header={header}
        code={selectedCode}
        open={open}
        setClose={() => setOpen(false)}
        useService={useService}
        reducer={reducer}
        item={item}
      />
      <ListingDatatable
        key={keyTrigger}
        header={header}
        columns={columns}
        filenameXML={filenameXML}
        setSelected={setSelected}
        setFormOpen={setOpen}
        setFormType={setFormType}
        menuCode={menuCode}
      />
    </>
  );
};

export default translate(AssetModel);
